// @flow
const boardCardStyle = {
  display: 'inline-block',
  float: 'none',
  verticalAlign: 'top',
};

export const hoverMaskStyle = {
  zIndex: 0,
};

export const boardNameStyle = {
  padding: '2px 0',
  fontSize: '18px',
  fontWeight: 'bold',
  color: '#555555',
};

export const boardNameDarkStyle = {
  padding: '2px 0',
  fontSize: '18px',
  fontWeight: 'bold',
  color: '#FFFFFF',
};

export const authorNameStyle = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '100%',
};

export const ownerAvatarStyle = {
  border: '2px solid #fff',
  borderRadius: '50%',
  position: 'absolute',
  bottom: 50,
  left: 8,
  width: 40,
  height: 40,
};

export const namePinCountStyle = {
  fontSize: '14px',
  color: '#555555',
  lineHeight: '1.14',
};

export const namePinCountDarkStyle = {
  fontSize: '14px',
  color: '#FFFFFF',
  lineHeight: '1.14',
};

export default boardCardStyle;
